import './FileRow.css';

import * as moment from 'moment';
import * as React from 'react';

import { UploadState } from '../reducers/uploadsReducer';
import { Spinner } from './Spinner';

interface IProps {
    file: File,
    state: UploadState,
    error: Error | null,
}

function humanFileSize(bytes: number) {
    const thresh = 1000;
    if(Math.abs(bytes) < thresh) {
        return bytes + ' B';
    }
    const units = ['kB','MB','GB','TB','PB','EB','ZB','YB'];
    let u = -1;
    do {
        bytes /= thresh;
        ++u;
    } while(Math.abs(bytes) >= thresh && u < units.length - 1);
    return bytes.toFixed(1)+' '+units[u];
}

const DoneIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 426.667 426.667"><path d="M213.333 0C95.518 0 0 95.514 0 213.333s95.518 213.333 213.333 213.333c117.828 0 213.333-95.514 213.333-213.333S331.157 0 213.333 0zm-39.134 322.918l-93.935-93.931 31.309-31.309 62.626 62.622 140.894-140.898 31.309 31.309-172.203 172.207z" fill="#6ac259"/></svg>);
const ErrorIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 426.667 426.667"><path d="M213.333 0C95.514 0 0 95.514 0 213.333s95.514 213.333 213.333 213.333 213.333-95.514 213.333-213.333S331.153 0 213.333 0zm117.662 276.689l-54.302 54.306-63.36-63.356-63.36 63.36-54.302-54.31 63.356-63.356-63.356-63.36 54.302-54.302 63.36 63.356 63.36-63.356 54.302 54.302-63.356 63.36 63.356 63.356z" fill="#f05228"/></svg>);

export class FileRow extends React.Component<IProps> {

    public render() {
        const {
            file,
        } = this.props;
        const {
            name,
            lastModified,
            size,
        } = file;

        return (<tr className="file-row">
            <td className="status">
            { this.stateIcon() }
            </td>
            <td className="file-name">{name}</td>
            <td className="last-modified">{moment(lastModified).format('YYYY-MM-DD HH:mm')}</td>
            <td className="file-size">{humanFileSize(size)}</td>
        </tr>);
    }

    private stateIcon() {
        switch (this.props.state) {
            case 'waiting':
                return null;
            case 'done':
                return (<DoneIcon />);
            case 'failed':
                return (<div onClick={this.showError}>
                    <ErrorIcon />
                </div>);
            case 'uploading':
                return (<Spinner size={20} />);
            default:
                return null;
        }
    }

    private showError = () => {
        const {error} = this.props;
        if (!error) {
            return;
        }
        alert(error.message);
    }

}

export default FileRow;



// WEBPACK FOOTER //
// ./src/components/FileRow.tsx